import { render } from "./SyallbusView.vue?vue&type=template&id=77876b16"
import script from "./SyallbusView.vue?vue&type=script&lang=js"
export * from "./SyallbusView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__